/*
 * @Author: 谢云龙
 * @Date: 2024-03-02 10:30:24
 * @LastEditors: 谢云龙
 * @LastEditTime: 2024-03-02 11:41:29
 * @Description: 商品在途数据存储
 */

import type {
  ITransiGoodsStore,
  ITransiGoodsModel,
} from '@monorepo/types/orders/transiGoods/transiGoods.types.ts';

const initState: ITransiGoodsStore = {
  isInit: true,
  tableList: [], // 商品汇总
  loationTableList: [], // 门店汇总
  orderTableList: [], // 单据号汇总
  total: 0,
  pageSize: 50,
  page: 1,
  sum: {},
  query: {
    summary: '',
  },
};

const transiGoodsStore: ITransiGoodsModel = {
  namespace: 'transiGoodsStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default transiGoodsStore;
